<!--
   Created by qing on 2020/9/4
   Des:
-->
<template>
  <div class="app-home-preview-container" v-wechat-title="appName">
    <div class="app-home-sub-container">
      <router-view/>
    </div>
    <van-tabbar route active-color="#4260FA">
      <van-tabbar-item
        v-for="item in tabList"
        :key="item.name"
        replace
        :to="item.route"
        :icon="item.icon">
        {{item.name}}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import {
    APP_TAB_TYPE_ALL_FORM,
    APP_TAB_TYPE_FORM_APPLY,
    APP_TAB_TYPE_DASH,
    APP_TAB_TYPE_TODO,
    APP_TAB_TYPE_WEBVIEW
  } from "../../../assets/types";

  export default {
    data() {
      return {
        appConfig: null,
        tabList: [],
        appName: ''
      }
    },
    async created() {

      await this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .then(res => {
          this.env = res.env
          this.to = res.to
          this.appConfig = res.appConfig
          this.$store.commit('UPDATE_ENV', res.env)
          this.$store.commit('UPDATE__USER_INFO', res.userInfo)
          this.$store.commit('UPDATE__COMPANY', res.company)
        })
        .catch(err => {
          console.error(err)
        })

      console.log('app -home-', this.$store.getters.currentAppId)

      await this.$store.dispatch('getAppDetail', {
        appId: this.$store.getters.currentAppId
      })
        .then(resultObject => {
          if (resultObject) {
            this.$store.commit('UPDATE__APP', resultObject)
          } else {
            this.$toast.fail('应用不存在，请退出重试')
          }
        }).catch(console.error)
      this.appName = this.$store.getters.currentApp.appName

      this.handleTabList()
    },
    methods: {
      handleTabList() {
        this.appConfig.menuItemList.forEach(item => {

          let route = ''
          if (item.menuType === APP_TAB_TYPE_ALL_FORM) {
            route = {
              path: '/app_preview/forms',
              query: {
                appId: this.$store.getters.currentAppId,
                showFormType: item.showFormType
              }
            }
          } else if (item.menuType === APP_TAB_TYPE_FORM_APPLY) {
            route = {
              path: '/app_preview/fillForm',
              query: {
                appId: this.$store.getters.currentAppId,
                formId: item.dataId
              }
            }
          } else if (item.menuType === APP_TAB_TYPE_DASH) {
            route = {
              path: '/app_preview/dashboard',
              query: {
                appId: this.$store.getters.currentAppId,
                dashId: item.dataId
              }
            }
          } else if (item.menuType === APP_TAB_TYPE_TODO) {
            route = {
              path: '/app_preview/flowTodo',
              query: {
                appId: this.$store.getters.currentAppId,
              }
            }
          } else if (item.menuType === APP_TAB_TYPE_WEBVIEW) {
            // FIXME 跳转url
          }

          this.tabList.push({
            route,
            icon: `i ${item.menuIcon}`, // 加i是因为van会自动在icon前面拼接一个van-icon-，导致iconfont加载不出来
            name: item.menuName
          })
        })
        console.log(this.tabList)
        if (this.tabList.length) {
          this.$router.replace(this.tabList[0].route)
        }
      },
    }
  }
</script>

<style lang="less">

  .app-home-preview-container {
    height: calc(100% - env(safe-area-inset-bottom));

    .app-home-sub-container {
      height: calc(100% - 50px);
    }
  }
</style>